/* eslint-disable react-hooks/exhaustive-deps */
import OptionsDropDown from "../UI/options_drop_down/options_drop_down";
import { genreOptions, gradeOptionsTools, readingComprehensionLength } from "../../constants";
import classes from "./criteriaSubmission.module.css";
import styles from "./assesmentForm/questionTypes/questionTypes.module.css";
import util from "../../styles/utilities.module.css";

import React, { useEffect, useState } from "react";
import DifficultyLevel from "./assesmentForm/difficultyLevel";
import Subject from "./assesmentForm/subject";
import UploadContent from "../UI/UploadContent/uploadContent";
import { useSelector, useDispatch } from "react-redux";
import {
  selectFormData,
  selectIncludeImages,
  setFormData,
  setSippsLevel,
  setSippsLesson,
  setIncludeImages,
  setIncludeParagraphNumbers,
  selectIncludeParagraphNumbers,
} from "../../slices/form";
import SippsLevelLessonSelector from "./assesmentForm/sippsQuestions/SippsLevelLessonSelector"; 

function CreateReadingComprehension({ isLoading }) {
  const [wordCount, setWordCount] = useState(0);
  const [charCount, setCharCount] = useState(null);

  const formData = useSelector(selectFormData);
  const dispatch = useDispatch();

  const { grade, genre, text, length, image_instructions, subject } = formData || {};
  const [useSippsLevel, setUseSippsLevel] = useState(false);
  const includeImages = useSelector(selectIncludeImages);
  const includeParagraphNumbers = useSelector(selectIncludeParagraphNumbers);

  function handleInputChange(event) {
    const { name } = event.target;
    let inputValue = event.target.value;
    let updates = { [name]: inputValue };

    if (name === "text" || name === "image_instructions") {
      // Main text area as limit of 5000, others 500
      let wordMax = (name === "text") ? 5000 : 500;
      let inputValue = event.target.value;
      const inputWords = inputValue?.split(/\s+/).filter(function (word) {
        return word.length > 0;
      });
      setWordCount(inputWords.length);
      setCharCount(null);
      if (inputWords.length > wordMax) {
        inputValue = inputWords.slice(0, wordMax).join(" "); // Modify inputValue
        setWordCount(inputWords.slice(0, wordMax).length);
        setCharCount(inputValue.length);
      }
    }

    dispatch(setFormData(updates));
  }

  useEffect(() => {
    // If subject is math, deselect "Include paragraph numbers" by default
    if (subject.toLowerCase() === 'math') {
      dispatch(setIncludeParagraphNumbers(false));
    }
  // Tool type is tracked globally via form.formType; no need to mirror it in formData
  }, [dispatch, subject]);

  useEffect(() => {
    // Automatically set genre based on subject
    if (subject && subject.toLowerCase() === 'math') {
      dispatch(setFormData({ genre: "Math" }));
    } else if (subject && subject.toLowerCase() !== 'math' && genre === "Math") {
      // Reset genre when switching away from math
      dispatch(setFormData({ genre: "" }));
    }
  }, [dispatch, subject, genre]);

  const handleUseSippsLevelChange = (event) => {
    setUseSippsLevel(event.target.checked);
    if (!event.target.checked) {
      dispatch(setSippsLevel(null));
      dispatch(setSippsLesson(null));
    } else {
      dispatch(setSippsLevel("beginning"));
      dispatch(setSippsLesson(30));
    }
  };

  const handleIncludeImagesChange = (event) => {
    const checked = event.target.checked;
    dispatch(setIncludeImages(checked)); // Update Redux state
    // Default image_speed when image selection changes
    dispatch(setFormData({ image_speed: "fast" }));
  }

  const handleImageSpeedChange = (event) => {
    const checked = event.target.checked;
    // If checked, set image_speed to "slow"; otherwise set it to "fast"
    dispatch(setFormData({ image_speed: checked ? "slow" : "fast" }));
  }

  const handleIncludeParagraphNumbersChange = (event) => {
    const checked = event.target.checked;
    dispatch(setIncludeParagraphNumbers(checked)); // Update Redux state
  }

  return (
    <>
      <Subject isLoading={isLoading} selectStoreData={selectFormData} setStoreData={setFormData} />
      <div className={classes["input-container"]}>
        <label className={classes.formLabel} htmlFor="grade">Select a grade:</label>
        <OptionsDropDown
          options={gradeOptionsTools}
          name="grade"
          onChangeHandler={handleInputChange}
          isDisabled={isLoading}
          value={grade || ""}
        />
      </div>
      {subject.toLowerCase() !== 'math' && (
      <div className={classes["input-container"]}>
        <label className={classes.formLabel} htmlFor="genre">Pick a genre:</label>
        <OptionsDropDown
          options={[{ name: "None selected", value: "" }, ...genreOptions]}
          name="genre"
          onChangeHandler={handleInputChange}
          isDisabled={isLoading}
          value={genre || ""}
        />
      </div>
      )}
      <DifficultyLevel
        isLoading={isLoading}
        handleInputChange={handleInputChange}
      />

      <div className={classes["input-container"]}>
        <label className={classes.formLabel} htmlFor="length">Specify the length:</label>
        <OptionsDropDown
          options={readingComprehensionLength}
          name="length"
          onChangeHandler={handleInputChange}
          isDisabled={isLoading}
          value={length || ""}
        />
      </div>

      <div className={classes["input-container"]}>
        <label className={classes.formLabel} htmlFor="text">
          {"Tell us more about the text you'd like the AI to create:"}
        </label>
        <div
          className={`${classes.textAreaContainer} ${classes.textAreaReadingComprehansion}`}
        >
          <textarea
            style={{ resize: "none" }}
            name="text"
            onChange={handleInputChange}
            className={`${util.input} ${classes.textArea} ${
              wordCount === 5000 ? classes.textAreaMax : ""
            }`}
            maxLength={charCount}
            placeholder={`Enter a topic or a description of what you'd like the AI to write about. For example, you could say "Why do volcanoes erupt?" or "Write a story about an unlucky gardener" or "Create a passage about Ancient Rome that incorporates the following vocabulary words: republic, gladiator, aqueduct, senate, plebeian, patrician, legion, triumvirate, Colosseum". You can also add special instructions.`}
            required={true}
            value={text}
            aria-label="Text description"
            aria-describedby="text-word-count"
          />
          <div className={classes.wordCount} id="text-word-count">({wordCount}/5000)</div>
        </div>
      </div>
      <UploadContent
        textLabel="Type/paste any special instructions here, and/or upload a file below:"
        textPlaceholder="Enter your special instructions or requests."
        nameInStore="text_instructions" 
        selectStoreData={selectFormData} 
        setStoreData={setFormData}
        textBoxHeight="100px"
      />
      <div className={styles.individualCheckbox} style={{ marginTop: "25px", marginBottom: "20px" }}>
        <label className={styles.container}>
          <input
            type="checkbox"
            checked={includeParagraphNumbers}
            onChange={handleIncludeParagraphNumbersChange}
            aria-label="Include paragraph numbers in text"
          />
          <span className={styles.checkmark}></span>
        </label>
        <span>Include paragraph numbers in text (recommended if students will reference generated text)</span>
      </div>
      <div className={styles.individualCheckbox} style={{ marginTop: "25px", marginBottom: "10px" }}>
        <label className={styles.container}>
          <input
            type="checkbox"
            checked={includeImages}
            onChange={handleIncludeImagesChange}
            aria-label="Include an image with the text"
          />
          <span className={styles.checkmark}></span>
        </label>
        <span>Include an image with the text</span>
      </div>

      { includeImages && (
        <>

          <div
            className={`${classes.textAreaContainer} ${classes.specialInstructionsContainer}`}
            style={{ marginLeft: 24, marginBottom: "15px" }}
          >
            <textarea
              style={{ resize: "none" }}
              name="image_instructions"
              onChange={handleInputChange}
              className={`${util.input} ${classes.textArea} ${
                wordCount === 500 ? classes.textAreaMax : ""
              }`}
              maxLength={charCount}
              placeholder={`Optionally steer the image generation here - describe the appearance of the characters, setting, etc. This field is optional.`}
              required={false}
              value={image_instructions}
              aria-label="Image instructions"
              aria-describedby="image-word-count"
            />
            <div className={classes.wordCount} id="image-word-count">({wordCount}/500)</div>
          </div>
          <div className={styles.individualCheckbox} style={{ marginLeft: 24, marginTop: 0, marginBottom: 10 }}>
            <label className={styles.container}>
              <input
                type="checkbox"
                checked={formData?.image_speed === "slow"}
                onChange={handleImageSpeedChange}
                aria-label="Slower, higher quality image generation"
              />
              <span className={styles.checkmark}></span>
            </label>
            <span>Slower, higher quality image generation</span>
          </div>
        </>
      )}


      { formData?.show_worksheet_tool && (
        <>
            <div className={styles.individualCheckbox} style={{ marginTop: "25px", marginBottom: "20px" }}>
            <label className={styles.container}>
              <input
                type="checkbox"
                checked={useSippsLevel}
                onChange={handleUseSippsLevelChange}
                aria-label="Level text to your school's ELA curriculum"
              />
              <span className={styles.checkmark}></span>
            </label>
            <span>Level text to your school's ELA curriculum</span>
          </div>
        
        <div className={classes["input-container"]}>
          {useSippsLevel && (
            <SippsLevelLessonSelector sippsLevel={null} sippsLesson={null} advancedOnly={true} />
          )}
        </div>
      </>
      )}

    </>
  );
}

export default CreateReadingComprehension;
